// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation, useParams } from "react-router-dom";
// import {
//   fetchUserDetails,
//   login,
//   otp,
//   removeCheckoutClientInfo,
//   switchUserRole,
// } from "../../services/authService";
// import ReCAPTCHA from "react-google-recaptcha";
// import "./Login.css";
// import Alert from "../HtmlElements/Alert";
// import { useUser } from "../../context/UserContext";
// import {
//   getUrlDetailsObj,
//   getUserStatsObject,
//   recordActivity,
// } from "../../services/commonService";
// import {
//   JS_CSS_IMG_VERSION,
//   PROJECT_DISPLAY_NAME,
// } from "../../config/apiConfig";
// import OTPVerification from "./OTPVerification";

// const Login = () => {
//   const [successMessage, setSuccessMessage] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const [recap, setRecap] = useState("");
//   const [showRecaptcha, setshowRecaptcha] = useState(0);
//   const [showOtpScreen, setShowOtpScreen] = useState(false);
//   const [tempApiToken, setTempApiToken] = useState(null);
//   const timerId = useRef(null);
//   const captchadisplaycount = 3;

//   const recaptchaRef = useRef(null);

//   const { user, setUser, setUserRole, handleLogout } = useUser();
//   const [showPassword, setShowPassword] = useState(false);
//   var pageParsedData = getUrlDetailsObj(useLocation, useParams);

//   var currentUrl = useLocation().pathname;

//   const toggleShowPassword = () => {
//     setShowPassword((prevShowPassword) => !prevShowPassword);
//   };
//   const checkCaptchaRender = () => {
//     var loginFailedCount = parseInt(localStorage.getItem("loginFailedCount"));
//     if (loginFailedCount >= captchadisplaycount) {
//       setshowRecaptcha(1);
//     }
//   };

//   useEffect(() => {
//     setRecap("");
//     recaptchaRef.current?.reset();
//   }, []);

//   useEffect(() => {
//     const successMessage = sessionStorage.getItem("successMessage");
//     if (successMessage) {
//       setSuccessMessage(successMessage);
//       sessionStorage.removeItem("successMessage"); // Clear the message
//     }

//     checkCaptchaRender();
//     // }, [showRecaptcha]);
//   }, []);

//   useEffect(() => {
//     if (error) {
//       //Creating a timeout
//       timerId.current = setTimeout(() => {
//         setError(false);
//       }, 5000);
//     }

//     return () => {
//       //Clearing timeout
//       clearTimeout(timerId.current);
//     };
//   }, [error]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // if (recap || !showRecaptcha) {
//     // if (recap || showRecaptcha !== 1) {
//     if (showRecaptcha === 1 && !recap) {
//       setError("Please complete the CAPTCHA to proceed.");
//       return;
//     } else {
//       // if (showRecaptcha === 1 && !recap) {
//       if (!email || !password) {
//         setError("Please enter both email and password.");
//         return;
//       }

//       setLoading(true);

//       try {
//         const isLogin = await login(email, password);
//         if (isLogin === true) {
//           // const userStat = {
//           //   type: "Login",
//           //   action: "login",
//           //   data: "Login successful",
//           //   page: currentUrl
//           // };
//           const userStat = getUserStatsObject(
//             "Login",
//             "login",
//             "Login successful",
//             currentUrl
//           );
//           userStat.url_details = pageParsedData;
//           recordActivity(userStat);
//           // navigate('/users');
//           localStorage.setItem("loginFailedCount", 0);
//           let userInfo = await fetchUserDetails();
//           let current_role_key = userInfo?.role_key;
//           /*
//           if(current_role_key === 'CLIENT'  && (userInfo?.is_onboarded == null || userInfo?.is_onboarded === 0)){
//             // window.location.replace("/accounts");
//             window.location.replace('/user_profile/profile');
//           }else{
//             window.location.replace("/users");
//           }
//           */

//           removeCheckoutClientInfo();

//           if (current_role_key === "SALES_DEMO") {
//             // navigate('/clients_accounts');
//             window.location.replace("/sales_accounts");
//           } else if (
//             current_role_key === "CLIENT" ||
//             current_role_key === "CLIENT_EMPLOYEE"
//           ) {
//             userInfo.is_onboarded = 1;
//             if (
//               userInfo?.is_onboarded == null ||
//               userInfo?.is_onboarded === 0
//             ) {
//               // navigate('/user_profile/profile');

//               // window.location.replace("/user_profile/profile");
//               window.location.replace("/watchboard");
//             } else {
//               // navigate('/dashboard');
//               window.location.replace("/watchboard");
//             }
//           } else {
//             window.location.replace("/users");
//           }
//         } else if (isLogin?.isOtp && isLogin?.api_token) {
//           setTempApiToken(isLogin?.api_token);
//           setShowOtpScreen(true);
//         } else {
//           // const userStat = {
//           //   type: "Login Attempt",
//           //   action: "Login_failed",
//           //   data: "Login failed",
//           //   page: currentUrl
//           // };
//           // const userStat = getUserStatsObject("Login Attempt", "Login_failed", "Login failed", currentUrl);
//           // recordActivity(userStat);
//           setError("Incorrect username or password. Please try again.");
//           var loginFailedCount = parseInt(
//             localStorage.getItem("loginFailedCount")
//           );
//           var loginFailed = parseInt(loginFailedCount) + 1;
//           localStorage.setItem("loginFailedCount", loginFailed);

//           checkCaptchaRender();

//           setRecap("");
//           recaptchaRef.current?.reset();
//         }
//       } catch (err) {
//         setError(err.message || "Login Failed");
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   return (
//     <div>
//       <div className="main-container">
//         <div className="main-content">
//           {!showOtpScreen ? (
//             <div className="login_page_wrapper">
//               <div className="sub_wrapper">
//                 <div className="row">
//                   {/* <div className="col-md-7 pr-0 same_height_block pl-0">
//                   <div className="login_left_block">
//                     <div className="login_new">
//                       <div className="row logo">
//                         <div className="cell">
//                           <div className="login_account_logo custom_row">
//                             <div className="cell">
//                               <img
//                                 src={`/img/mnm_logo_inner.png?version=${JS_CSS_IMG_VERSION}`}
//                                 alt="logo"
//                                 width="140"
//                                 className="logo_login"
//                               />
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="row middle_content">
//                         <div className="cell">
//                           <div className="login_content custom_row">
//                             <h5 className="login_subhead">
//                               Unlock the Power of Client Insights and
//                               Supercharge Your Sales with {PROJECT_DISPLAY_NAME}
//                               !
//                             </h5>
//                             <p className="login_para">
//                               Get a 360° view of your clients, uncover untapped
//                               opportunities, and create unstoppable sales
//                               pipelines—all with our ultimate sales intelligence
//                               platform.
//                             </p>
//                             <div className="login_list">
//                               <div className="login_li">
//                                 <img src="/img/3x.png" className="img_icon" />
//                                 <p className="login_li_span">
//                                   Faster Account Research:
//                                 </p>
//                                 <p className="login_li_para">
//                                   Optimize your sales preparation with
//                                   AI-powered insights, saving you valuable
//                                   weekly hours on client analysis.
//                                 </p>
//                               </div>
//                               <div className="login_li">
//                                 <img
//                                   src="/img/rates.png"
//                                   className="img_icon"
//                                 />
//                                 <p className="login_li_span">
//                                   Boost Pipeline Growth by 40%:
//                                 </p>
//                                 <p className="login_li_para">
//                                   Discover new buying centers and unlock
//                                   opportunities that drive your sales targets.
//                                 </p>
//                               </div>
//                               <div className="login_li">
//                                 <img
//                                   src="/img/boost.png"
//                                   className="img_icon"
//                                 />
//                                 <p className="login_li_span">
//                                   Increase Win Rates by 25%:
//                                 </p>
//                                 <p className="login_li_para">
//                                   Leverage tailored talk tracks and actionable
//                                   strategies to close deals confidently.
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="row base">
//                         <div className="cell">
//                           <div className="login_bottom_mail custom_row">
//                             <div className="cell">
//                               <div className="d-flexn">
//                                 <div className="email_block_left">
//                                   <a
//                                     target="_blank"
//                                     href="https://www.marketsandmarkets.com"
//                                     className="link_mail"
//                                   >
//                                     <i
//                                       className="fa fa-globe mr-2"
//                                       aria-hidden="true"
//                                     ></i>{" "}
//                                     <span className="url_email">
//                                       {" "}
//                                       www.marketsandmarkets.com{" "}
//                                     </span>{" "}
//                                   </a>
//                                 </div>
//                                 <div className="email_block">
//                                   <a
//                                     href="mailto:salesiq@marketsandmarkets.com"
//                                     className="link_mail"
//                                   >
//                                     <i
//                                       className="fa fa-envelope-open mr-2"
//                                       aria-hidden="true"
//                                     ></i>{" "}
//                                     <span className="url_email">
//                                       {" "}
//                                       salesiq@marketsandmarkets.com
//                                     </span>{" "}
//                                   </a>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div> */}
//                   <div
//                     className="col-md-5 pl-0 same_height_right"
//                     style={{ margin: "0 auto" }}
//                   >
//                     <div className="login_right_block ">
//                       <div className="login_block">
//                         <div className="login_top_icon vis_hidden">
//                           <img
//                             src="/img/login/flag.png"
//                             alt="logo"
//                             width="50"
//                             className="login_icon"
//                           />
//                         </div>
//                         <h5 className="login_head">Login</h5>
//                         <p className="login_para">
//                           Please enter your email and password
//                         </p>
//                         <div className="main_form_login">
//                           {successMessage && (
//                             <Alert type="success" message={successMessage} />
//                           )}
//                           {error && <Alert type="danger" message={error} />}
//                           <form onSubmit={handleSubmit}>
//                             <div className="mb-3">
//                               <label
//                                 htmlFor="email"
//                                 className="form-label custom_label"
//                               >
//                                 Email
//                               </label>
//                               <span className="block input-icon input-icon-right">
//                                 <input
//                                   type="email"
//                                   className="form-control custom_form_control"
//                                   id="email"
//                                   placeholder="Please enter your Email Address"
//                                   autoComplete="off"
//                                   value={email}
//                                   onChange={(e) => setEmail(e.target.value)}
//                                 />
//                               </span>
//                             </div>

//                             <div className="mb-3">
//                               <label
//                                 htmlFor="password"
//                                 className="form-label custom_label"
//                               >
//                                 Password
//                               </label>
//                               <span className="block input-icon input-icon-right">
//                                 <input
//                                   type={showPassword ? "text" : "password"}
//                                   className="form-control custom_form_control"
//                                   id="password"
//                                   placeholder="Please enter your Password"
//                                   autoComplete="off"
//                                   value={password}
//                                   onChange={(e) => setPassword(e.target.value)}
//                                 />
//                                 <div
//                                   className="input-group-append"
//                                   style={{
//                                     position: "absolute",
//                                     right: "10px",
//                                     top: "7px",
//                                     zIndex: "5",
//                                   }}
//                                 >
//                                   <span
//                                     className=""
//                                     onClick={toggleShowPassword}
//                                     style={{ cursor: "pointer" }}
//                                   >
//                                     <i
//                                       className={`fa fa-eye${
//                                         showPassword ? "" : "-slash"
//                                       }`}
//                                       aria-hidden="true"
//                                     ></i>
//                                   </span>
//                                 </div>
//                               </span>
//                             </div>

//                             {/* {showRecaptcha === 1 && (
//                               <div className="mb-3">
//                                 <ReCAPTCHA
//                                   sitekey="6LdrhAwqAAAAAGG8IdTF7Y1cYyH3tA4aMkzWli0f"
//                                   onChange={(val) => setRecap(val)}
//                                 />
//                               </div>
//                             )} */}

//                             {showRecaptcha === 1 && (
//                               <div className="mb-3">
//                                 {/* <ReCAPTCHA
//                                   // sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
//                                   sitekey="6LdrhAwqAAAAAGG8IdTF7Y1cYyH3tA4aMkzWli0f"
//                                   onChange={(val) => setRecap(val)}
//                                   onErrored={() => {
//                                     // Allowed to login if captcha domain breaks
//                                     setshowRecaptcha(0);
//                                     setRecap("bypass");
//                                   }}
//                                   onExpired={() => setRecap("")}
//                                 /> */}
//                                 <ReCAPTCHA
//                                   ref={recaptchaRef}
//                                   sitekey="6LdrhAwqAAAAAGG8IdTF7Y1cYyH3tA4aMkzWli0f"
//                                   onChange={(val) => setRecap(val)}
//                                   onExpired={() => {
//                                     setRecap("");
//                                     recaptchaRef.current?.reset();
//                                   }}
//                                   onErrored={() => {
//                                     setRecap("");
//                                     // setshowRecaptcha(0);
//                                     recaptchaRef.current?.reset();
//                                   }}
//                                 />
//                               </div>
//                             )}

//                             <div className="space-6"></div>
//                             <button
//                               disabled={loading}
//                               type="submit"
//                               className="btn btn-primary custom_log_btn w-100"
//                             >
//                               {loading ? (
//                                 <i className="fa fa-spinner fa-spin"></i>
//                               ) : (
//                                 <i className="fa fa-keyj"></i>
//                               )}{" "}
//                               Login
//                             </button>

//                             {/* <div className="forgot_block">
//                             <span className="forgot_span">
//                               {" "}
//                               <a
//                                 href="/forgotpassword"
//                                 className="forgot_password"
//                               >
//                                 Forgot Password ?
//                               </a>
//                             </span>
//                           </div> */}
//                           </form>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ) : (
//             // <div class="otp_wrapper">
//             //   <div class="container otp_block d-flex justify-content-center align-items-center">
//             //     {successMessage && (
//             //       <Alert type="success" message={successMessage} />
//             //     )}
//             //     {error && <Alert type="danger" message={error} />}
//             //     <form onSubmit={handleOtpSubmit}>
//             //       <div class="position-relative">
//             //         <div class="card text-center otp_card_block">
//             //           <img
//             //             src="/img/otp.svg"
//             //             class="icon_otp mb-3 mt-3"
//             //             alt="icon"
//             //             width="50"
//             //           />
//             //           <h6>
//             //             Please enter the one time password <br /> to verify your
//             //             account
//             //           </h6>
//             //           <div>
//             //             {" "}
//             //             <span>A code has been sent to</span>{" "}
//             //             <small id="maskedNumber">shrideshmukh@gmail.com</small>{" "}
//             //           </div>
//             //           <div
//             //             id="otp"
//             //             class="otp_card_inputs d-flex flex-row justify-content-center mt-2"
//             //           >
//             //             <input
//             //               class="m-2 text-center form-control rounded"
//             //               type="text"
//             //               id="first"
//             //               maxlength="1"
//             //             />
//             //             <input
//             //               class="m-2 text-center form-control rounded"
//             //               type="text"
//             //               id="second"
//             //               maxlength="1"
//             //             />
//             //             <input
//             //               class="m-2 text-center form-control rounded"
//             //               type="text"
//             //               id="third"
//             //               maxlength="1"
//             //             />
//             //             <input
//             //               class="m-2 text-center form-control rounded"
//             //               type="text"
//             //               id="fourth"
//             //               maxlength="1"
//             //             />
//             //             <input
//             //               class="m-2 text-center form-control rounded"
//             //               type="text"
//             //               id="fifth"
//             //               maxlength="1"
//             //             />
//             //             <input
//             //               class="m-2 text-center form-control rounded"
//             //               type="text"
//             //               id="sixth"
//             //               maxlength="1"
//             //             />
//             //           </div>
//             //           <div class="mt-4">
//             //             <button
//             //               id="validateBtn"
//             //               class="btn btn-danger px-4 validate"
//             //             >
//             //               Submit
//             //             </button>
//             //           </div>
//             //         </div>
//             //       </div>
//             //     </form>
//             //   </div>
//             // </div>

//             <OTPVerification
//               tempApiToken={tempApiToken}
//               email={email}
//               setTempApiToken={setTempApiToken}
//               setShowOtpScreen={setShowOtpScreen}
//               currentUrl={currentUrl}
//               pageParsedData={pageParsedData}
//             />
//           )}
//           {/* <div className="login-container">
//                 <div className="center">
//                   <h4 className="blue" id="id-company-text">
//                     <img src="/img/mnm_logo_inner.png" width="200" alt="Logo" />
//                   </h4>
//                 </div>
//                 <div className="space-4"></div>

//                 <h2 className="login_head header blue">
//                   <i className="ace-icon fa fa-sign-in blue mr-2"></i>Please
//                   Enter Your Information
//                 </h2>
//                 <div className="space-6"></div>
//                 {successMessage && (
//                   <Alert type="success" message={successMessage} />
//                 )}
//                 {error && <Alert type="danger" message={error} />}
//                 <form onSubmit={handleSubmit}>
//                   <div className="mb-3">
//                     <label htmlFor="email" className="form-label custom_label">
//                       Email Address
//                     </label>
//                     <span className="block input-icon input-icon-right">
//                       <input
//                         type="email"
//                         className="form-control custom_form_control"
//                         id="email"
//                         placeholder="Please enter your Email Address"
//                         autoComplete="off"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                       />
//                       <i className="ace-icon fa fa-user"></i>
//                     </span>
//                   </div>

//                   <div className="mb-3">
//                     <label
//                       htmlFor="password"
//                       className="form-label custom_label"
//                     >
//                       Password
//                     </label>
//                     <span className="block input-icon input-icon-right">
//                       <input
//                         type="password"
//                         className="form-control custom_form_control"
//                         id="password"
//                         placeholder="Please enter your Password"
//                         autoComplete="off"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                       />
//                       <i className="ace-icon fa fa-lock"></i>
//                     </span>
//                   </div>

//                   {showRecaptcha === 1 && (
//                     <div className="mb-3">
//                       <ReCAPTCHA
//                         sitekey="6LdrhAwqAAAAAGG8IdTF7Y1cYyH3tA4aMkzWli0f"
//                         onChange={(val) => setRecap(val)}
//                       />
//                     </div>
//                   )}

//                   <div className="">
//                     <a href="/forgotpassword" className="forgot_password">
//                       Forgot Password ?
//                     </a>
//                   </div>

//                   <div className="space-6"></div>
//                   <button
//                     disabled={loading}
//                     type="submit"
//                     className="btn btn-primary custom_login_btn width-35 pull-right"
//                   >
//                     {loading ? (
//                       <i className="fa fa-spinner fa-spin"></i>
//                     ) : (
//                       <i className="fa fa-key"></i>
//                     )}{" "}
//                     Login
//                   </button>

//                 </form>
//               </div>  */}

//           <div class="otp_wrapper d-none">
//             <div class="container otp_block d-flex justify-content-center align-items-center">
//               <div class="position-relative">
//                 <div class="card text-center otp_card_block">
//                   <img
//                     src="/img/otp.svg"
//                     class="icon_otp mb-3 mt-3"
//                     alt="icon"
//                     width="50"
//                   />
//                   <h6>
//                     Please enter the one time password <br /> to verify your
//                     account
//                   </h6>
//                   <div>
//                     {" "}
//                     <span>A code has been sent to</span>{" "}
//                     <small id="maskedNumber">shrideshmukh@gmail.com</small>{" "}
//                   </div>
//                   <div
//                     id="otp"
//                     class="otp_card_inputs d-flex flex-row justify-content-center mt-2"
//                   >
//                     <input
//                       class="m-2 text-center form-control rounded"
//                       type="text"
//                       id="first"
//                       maxlength="1"
//                     />
//                     <input
//                       class="m-2 text-center form-control rounded"
//                       type="text"
//                       id="second"
//                       maxlength="1"
//                     />
//                     <input
//                       class="m-2 text-center form-control rounded"
//                       type="text"
//                       id="third"
//                       maxlength="1"
//                     />
//                     <input
//                       class="m-2 text-center form-control rounded"
//                       type="text"
//                       id="fourth"
//                       maxlength="1"
//                     />
//                     <input
//                       class="m-2 text-center form-control rounded"
//                       type="text"
//                       id="fifth"
//                       maxlength="1"
//                     />
//                     <input
//                       class="m-2 text-center form-control rounded"
//                       type="text"
//                       id="sixth"
//                       maxlength="1"
//                     />
//                   </div>
//                   <div class="mt-4">
//                     <button
//                       id="validateBtn"
//                       class="btn btn-danger px-4 validate"
//                     >
//                       Submit
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
  useSearchParams,
  useNavigate,
  useLocation,
  useParams,
  Navigate,
} from "react-router-dom";

import {
  fetchUserDetails,
  login,
  otp,
  removeCheckoutClientInfo,
  switchUserRole,
} from "../../services/authService";
import ReCAPTCHA from "react-google-recaptcha";
import "./Login.css";
import Alert from "../HtmlElements/Alert";
import { useUser } from "../../context/UserContext";
import * as FeatherIcon from "react-feather";

import {
  getUrlDetailsObj,
  getUserStatsObject,
  recordActivity,
  routeBasedOnSubscription,
} from "../../services/commonService";
import {
  JS_CSS_IMG_VERSION,
  PROJECT_DISPLAY_NAME,
} from "../../config/apiConfig";
import OTPVerification from "./OTPVerification";
import LoginFooter from "./LoginFooter";
import LoginForm from "./LoginForm";
import GrowthIQTabs from "./GrowthIQTabs"; // Import GrowthIQTabs
import ExpandableVerticalSections from "./ExpandableVerticalSections"; // Import ExpandableVerticalSections
import {
  clearForgotPasswordState,
  forgotPasswordRequest,
  forgotPasswordSuccessMessage,
  forgotPasswordError,
  forgotPasswordLoading,
} from "./../../store/features/actions/forgotPasswordActions";

const Login = () => {
  const dispatch = useDispatch();
  const [successMessage, setSuccessMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [recap, setRecap] = useState("");
  const [showRecaptcha, setShowRecaptcha] = useState(false);
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [tempApiToken, setTempApiToken] = useState(null);
  const timerId = useRef(null);
  // const captchaDisplayCount = 3;

  const recaptchaRef = useRef(null);

  const { user, setUser, setUserRole, handleLogout } = useUser();
  const [showPassword, setShowPassword] = useState(false);
  const [ksStatusMessage, setKsStatusMessage] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  var pageParsedData = getUrlDetailsObj(useLocation, useParams);
  var currentUrl = useLocation().pathname;

  const toggleShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const {
    forgotPasswordSuccessMessage,
    forgotPasswordError,
    forgotPasswordLoading,
  } = useSelector((state) => state.forgotPasswordReducer);

  // const checkCaptchaRender = () => {
  //   const loginFailedCount = parseInt(localStorage.getItem("loginFailedCount")) || 0;
  //   if (loginFailedCount >= captchaDisplayCount) {
  //     setShowRecaptcha(true);
  //   }
  // };

  const [searchParams] = useSearchParams();
  const v = searchParams.get("v");

  useEffect(() => {
    if (v === "true")
      setKsStatusMessage(
        "Your account is activated successfully. You can start using your account."
      );
    else if (v === "false")
      setKsStatusMessage(
        "Error activating your account. The link is invalid or your account is already activated."
      );

    setTimeout(() => {
      setKsStatusMessage("");
    }, 8000);
  }, []);

  // Initialize component - check if captcha should be shown
  useEffect(() => {
    const successMessage = sessionStorage.getItem("successMessage");
    if (successMessage) {
      setSuccessMessage(successMessage);
      sessionStorage.removeItem("successMessage");
    }

    // checkCaptchaRender();
  }, []); // Only run once on mount

  // Handle error timeout
  useEffect(() => {
    if (error) {
      timerId.current = setTimeout(() => {
        setError("");
      }, 5000);
    }

    return () => {
      clearTimeout(timerId.current);
    };
  }, [error]);

  // const resetCaptcha = () => {
  //   setRecap("");
  //   if (recaptchaRef.current) {
  //     recaptchaRef.current.reset();
  //   }
  // };

  useEffect(() => {
    if (forgotPasswordSuccessMessage) {
      const timer = setTimeout(() => {
        setShowForgotPassword(false);
        setForgotEmail("");
        dispatch(clearForgotPasswordState());
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [forgotPasswordSuccessMessage]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate captcha if it's shown
    // if (showRecaptcha && !recap) {
    //   setError("Please complete the CAPTCHA to proceed.");
    //   return;
    // }

    if (!email || !password) {
      setError("Please enter both email and password.");
      return;
    }

    setLoading(true);

    try {
      const isLogin = await login(email, password);

      if (isLogin === true) {
        const userStat = getUserStatsObject(
          "Login",
          "login",
          "Login successful",
          currentUrl
        );
        userStat.url_details = pageParsedData;
        recordActivity(userStat);

        localStorage.setItem("loginFailedCount", "0");
        let userInfo = await fetchUserDetails();
        setUser(userInfo);

        let current_role_key = userInfo?.role_key;
        let growthiq_role = userInfo?.growth_iq_role_name;

        removeCheckoutClientInfo();
        const routePath = routeBasedOnSubscription(userInfo, handleLogout);
        if (routePath) {
          navigate(routePath, { replace: true });
        }

        // if (userInfo?.growth_iq === 1) {
        //   if (growthiq_role === "ROLE_ACCOUNT_MANAGER") {
        //     window.location.replace("/sales_accounts");
        //   } else if (
        //     growthiq_role === "CLIENT" ||
        //     growthiq_role === "CLIENT_EMPLOYEE"
        //   ) {
        //     userInfo.is_onboarded = 1;
        //     if (
        //       userInfo?.is_onboarded == null ||
        //       userInfo?.is_onboarded === 0
        //     ) {
        //       window.location.replace("/watchboard");
        //     } else {
        //       window.location.replace("/watchboard");
        //     }
        //   } else {
        //     window.location.replace("/users");
        //   }
        // } else {
        //   handleLogout();
        // }

        // if (current_role_key === "SALES_DEMO") {
        //   window.location.replace("/sales_accounts");
        // } else if (
        //   current_role_key === "CLIENT" ||
        //   current_role_key === "CLIENT_EMPLOYEE"
        // ) {
        //   userInfo.is_onboarded = 1;
        //   if (userInfo?.is_onboarded == null || userInfo?.is_onboarded === 0) {
        //     window.location.replace("/watchboard");
        //   } else {
        //     window.location.replace("/watchboard");
        //   }
        // } else {
        //   window.location.replace("/users");
        // }
      } else if (isLogin?.isOtp && isLogin?.api_token) {
        setTempApiToken(isLogin?.api_token);
        setShowOtpScreen(true);
      } else {
        setError("Incorrect username or password. Please try again.");

        const currentCount =
          parseInt(localStorage.getItem("loginFailedCount")) || 0;
        const newCount = currentCount + 1;
        localStorage.setItem("loginFailedCount", newCount.toString());

        // Show captcha if threshold reached
        // if (newCount >= captchaDisplayCount) {
        //   setShowRecaptcha(true);
        // }

        // Reset captcha for next attempt
        // resetCaptcha();
      }
    } catch (err) {
      setError(err.message || "Login Failed");
      // resetCaptcha();
    } finally {
      setLoading(false);
    }
  };

  const handleCaptchaChange = (value) => {
    setRecap(value);
  };

  const handleCaptchaExpired = () => {
    setRecap("");
  };

  const handleCaptchaError = () => {
    setRecap("");
    setError("reCAPTCHA error. Please try again.");
  };

  const tabData = [
    {
      label: "Consulting Projects",
      icon: "/img/login/consulting_projects.png",
      text: "Consulting Projects",
    },
    {
      label: "Self-Service Strategy",
      icon: "/img/login/self_service_strategy.png",
      text: "Self-Service Strategy",
    },
    {
      label: "Data Access",
      icon: "/img/login/data_access.png",
      text: "Data Access",
    },
    {
      label: "Decision Automation",
      icon: "/img/login/decision_automation.png",
      text: "Decision Automation",
    },
  ];

  const GrowthIqBlock = () => {
    return <GrowthIQTabs tabData={tabData} />;
  };

  const handleForgotPasswordSubmit = (e) => {
    e.preventDefault();

    if (!forgotEmail) return;

    dispatch(
      forgotPasswordRequest({
        email: forgotEmail,
      })
    );
  };

  return (
    <div>
      <div className="main-container-login">
        {/* <div className="main-content">
          {!showOtpScreen ? (
            <div className="login_page_wrapper">
              <div className="sub_wrapper">
                <div className="row">
                  <div
                    className="col-md-5 pl-0 same_height_right"
                    style={{ margin: "0 auto" }}
                  >
                    <div className="login_right_block">
                      <div className="login_block">
                        <div className="login_top_icon vis_hidden">
                          <img
                            src="/img/login/flag.png"
                            alt="logo"
                            width="50"
                            className="login_icon"
                          />
                        </div>
                        <h5 className="login_head">Login</h5>
                        <p className="login_para">
                          Please enter your email and password
                        </p>
                        <div className="main_form_login">
                          {successMessage && (
                            <Alert type="success" message={successMessage} />
                          )}
                          {error && <Alert type="danger" message={error} />}
                          <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                              <label
                                htmlFor="email"
                                className="form-label custom_label"
                              >
                                Email
                              </label>
                              <span className="block input-icon input-icon-right">
                                <input
                                  type="email"
                                  className="form-control custom_form_control"
                                  id="email"
                                  placeholder="Please enter your Email Address"
                                  autoComplete="off"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  disabled={loading}
                                />
                              </span>
                            </div>

                            <div className="mb-3">
                              <label
                                htmlFor="password"
                                className="form-label custom_label"
                              >
                                Password
                              </label>
                              <span className="block input-icon input-icon-right">
                                <input
                                  type={showPassword ? "text" : "password"}
                                  className="form-control custom_form_control"
                                  id="password"
                                  placeholder="Please enter your Password"
                                  autoComplete="off"
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  disabled={loading}
                                />
                                <div
                                  className="input-group-append"
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "7px",
                                    zIndex: "5",
                                  }}
                                >
                                  <span
                                    className=""
                                    onClick={toggleShowPassword}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i
                                      className={`fa fa-eye${
                                        showPassword ? "" : "-slash"
                                      }`}
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                </div>
                              </span>
                            </div>

                            {/* Uncomment when reCAPTCHA is configured with valid site key */}
        {/* {showRecaptcha && (
                              <div className="mb-3">
                                <ReCAPTCHA
                                  ref={recaptchaRef}
                                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                  onChange={handleCaptchaChange}
                                  onExpired={handleCaptchaExpired}
                                  onErrored={handleCaptchaError}
                                />
                              </div>
                            )} */}

        {/* <div className="space-6"></div>
                            <button
                              disabled={loading}
                              type="submit"
                              className="btn btn-primary custom_log_btn w-100"
                            >
                              {loading ? (
                                <i className="fa fa-spinner fa-spin"></i>
                              ) : (
                                <i className="fa fa-key"></i>
                              )}{" "}
                              Login
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
        {/* ) : (
            <OTPVerification
              // tempApiToken={tempApiToken}
              // email={email}
              // setTempApiToken={setTempApiToken}
              // setShowOtpScreen={setShowOtpScreen}
              // currentUrl={currentUrl}
              // pageParsedData={pageParsedData}
              // handleLogout={handleLogout}
            />
          )}
        </div> */}
      </div>

      {/* New Login Page Start */}
      <div className="login_page_wrapper">
        <div className="top_navbar_login">
          <nav
            class="navbar navbar-expand-lg navbar-light bg-white shadow-sm"
            style={{ minHeight: "70px" }}
          >
            <div class="container">
              <a class="navbar-brand" href="#">
                <img
                  src="/img/login/Growth-IQ_black_logo.png"
                  alt="icon"
                  className="top_logo"
                />
                <p className="powered_by">powered by knowledgeStore</p>
              </a>

              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarContent"
              >
                <span class="navbar-toggler-icon"></span>
              </button>

              <div class="collapse navbar-collapse" id="navbarContent">
                <div class="ms-auto">
                  <div class="right-text">
                    <div class="us-no">
                      <span class="mobile-no">
                        <FeatherIcon.Phone className="comp_icon" />
                        US +1 (206) 401-8844
                      </span>
                    </div>
                    <div class="us-no">
                      <span class="mobile-no">
                        <FeatherIcon.Phone className="comp_icon" />
                        UK +44 20 3869 5400
                      </span>
                    </div>
                    <div class="us-no">
                      <span class="email-no">
                        <FeatherIcon.Mail className="comp_icon" />
                        <a
                          href="mailto:mnmkssupport@marketsandmarkets.com"
                          className="top_email"
                        >
                          Email
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
        {!showOtpScreen ? (
          <div className="top_banner_wrapper" id="login_form_section">
            <div className="container">
              <div className="row">
                <div className="col-md-8">
                  <div className="top_right_block_wrapper">
                    <div className="the_future_block">
                      <p className="the_future_block_para">
                        The Future of Strategic Intelligence
                      </p>
                    </div>
                    <div className="start_int_block">
                      <h1 className="start_int_head">
                        Strategic Intelligence
                        <img
                          src="/img/login/ai_login_icon.png"
                          alt="icon"
                          className="ai_icon"
                        />
                        <br />
                        That Moves at the <br />
                        Speed of Business
                      </h1>
                      <p className="start_int_subhead">
                        Real-time market intelligence platform
                        <br /> transforming how enterprise teams access,
                        <br /> analyze, and act on strategic insights.
                      </p>
                    </div>
                    <div className="start_small_blocks">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="start_small_subblock">
                            <img
                              src="/img/login/weeks_saved.png"
                              alt="icon"
                              className="icon"
                            />
                            <p className="score">95%</p>
                            <p className="score_text">Time Reduction</p>
                          </div>
                        </div>
                        {/* <div className="col-md-3">
                        <div className="start_small_subblock">
                          <img
                            src="/img/login/faster.png"
                            alt="icon"
                            className="icon"
                          />
                          <p className="score">100%</p>
                          <p className="score_text">Faster</p>
                        </div>
                      </div> */}
                        <div className="col-md-3">
                          <div
                            className="start_small_subblock border-right-none"
                            style={{ paddingLeft: "20px" }}
                          >
                            <img
                              src="/img/login/quality.png"
                              alt="icon"
                              className="icon"
                            />
                            <p className="score">360°</p>
                            <p className="score_text">Complete View</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <LoginForm
                    email={email}
                    setEmail={setEmail}
                    password={password}
                    setPassword={setPassword}
                    showPassword={showPassword}
                    toggleShowPassword={toggleShowPassword}
                    // loading={loading}
                    handleSubmit={handleSubmit}
                    showRecaptcha={showRecaptcha}
                    recaptchaRef={recaptchaRef}
                    handleCaptchaChange={handleCaptchaChange}
                    handleCaptchaExpired={handleCaptchaExpired}
                    handleCaptchaError={handleCaptchaError}
                    // successMessage={successMessage}
                    // error={error}
                    showForgotPassword={showForgotPassword}
                    setShowForgotPassword={setShowForgotPassword}
                    forgotEmail={forgotEmail}
                    setForgotEmail={setForgotEmail}
                    handleForgotPasswordSubmit={handleForgotPasswordSubmit}
                    successMessage={
                      showForgotPassword
                        ? forgotPasswordSuccessMessage
                        : successMessage
                    }
                    error={showForgotPassword ? forgotPasswordError : error}
                    loading={forgotPasswordLoading || loading}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="otp_view_container" style={{ padding: "0 0" }}>
            <OTPVerification
              tempApiToken={tempApiToken}
              email={email}
              setTempApiToken={setTempApiToken}
              setShowOtpScreen={setShowOtpScreen}
              currentUrl={currentUrl}
              pageParsedData={pageParsedData}
              handleLogout={handleLogout}
            />
          </div>
        )}
        {!showOtpScreen ? (
          <>
            <div className="static_reports">
              <div className="container">
                <div className="static_reprorts_block">
                  <h1 className="static_reports_head">
                    From Static Reports to Continuous Intelligence
                  </h1>
                  <p className="static_reports_subhead">
                    The market intelligence landscape has fundamentally changed.
                    Strategy teams need intelligence that <br /> evolves with
                    their business.
                  </p>
                </div>
                <div className="static_reports_block">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="static_arrow_block">
                        <div className="static_arrow_firstblock">
                          <img
                            src="/img/login/static_reports.png"
                            alt="icon"
                            className="static_icon"
                          />
                          <p className="arrow_text">
                            Static <br /> Reports
                          </p>
                        </div>
                        <div className="static_arrow_middleblock">
                          <img
                            src="/img/login/arrow_middle.png"
                            alt="icon"
                            className="arrow_icon"
                          />
                        </div>
                        <div className="static_arrow_lastblock">
                          <img
                            src="/img/login/realtime_intelligence.png"
                            alt="icon"
                            className="static_icon"
                          />
                          <p className="arrow_text">
                            Real-Time <br /> Intelligence
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="static_arrow_block">
                        <div className="static_arrow_firstblock">
                          <img
                            src="/img/login/consulting_projects.png"
                            alt="icon"
                            className="static_icon"
                          />
                          <p className="arrow_text">
                            Consulting <br /> Projects
                          </p>
                        </div>
                        <div className="static_arrow_middleblock">
                          <img
                            src="/img/login/arrow_middle.png"
                            alt="icon"
                            className="arrow_icon"
                          />
                        </div>
                        <div className="static_arrow_lastblock">
                          <img
                            src="/img/login/self_service_strategy.png"
                            alt="icon"
                            className="static_icon"
                          />
                          <p className="arrow_text">
                            Self-Service <br />
                            Strategy
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="static_arrow_block">
                        <div className="static_arrow_firstblock">
                          <img
                            src="/img/login/data_access.png"
                            alt="icon"
                            className="static_icon"
                          />
                          <p className="arrow_text">
                            Data <br />
                            Access
                          </p>
                        </div>
                        <div className="static_arrow_middleblock">
                          <img
                            src="/img/login/arrow_middle.png"
                            alt="icon"
                            className="arrow_icon"
                          />
                        </div>
                        <div className="static_arrow_lastblock">
                          <img
                            src="/img/login/decision_automation.png"
                            alt="icon"
                            className="static_icon"
                          />
                          <p className="arrow_text">
                            Decision <br />
                            Automation
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <GrowthIqBlock />

            <div className="build_for_wrapper">
              <div className="container">
                <div className="build_for_block">
                  <h1 className="build_for_head">
                    Built for How Strategic Teams Actually Work
                  </h1>
                  <p className="build_for_subhead">
                    Explore impact for each team
                  </p>
                </div>
                <div className="build_for_reports_block">
                  <div className="row">
                    {/* <div className="strat_teams_block">
                    <h5 className="strat_teams_head">Strategy Teams</h5>
                    <div className="strat_number_blocks">
                      <div className="left_block">
                        <div className="left_subblock">
                          <p className="left_subhead">Faster <br/> Planning</p>
                          <p className="left_number">75%</p>
                        </div>
                        <div className="left_image_block">
                          <img src="/img/login/faster_planning.png" className="img_icon" alt="payment icon"/>
                        </div>
                      </div>
                      <div className="right_block">
                        <div className="right_subblock">
                          <p className="right_subhead">Cost <br/> Savings</p>
                          <p className="right_number">$500K+</p>
                        </div>
                        <div className="right_image_block">
                          <img src="/img/login/cost_savings.png" className="img_icon" alt="payment icon"/>
                        </div>
                      </div>

                    </div>
                    <div className="strat_list_block">
                    <ul class="tab_left_ul">
                              <li class="tab_left_list">
                                  <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                                      >Accelerate planning cycles from quarters to weeks</span>
                              </li>
                              <li class="tab_left_list">
                                  <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                                      >Replace multiple research subscriptions</span>
                              </li>
                              <li class="tab_left_list">
                                  <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                                      >Enable continuous strategy refinement</span>
                              </li>
                              <li class="tab_left_list">
                                  <img src="/img/login/list_white.png" class="icon_tick" alt="tick icon" /><span class="list_span"
                                      >Support data-driven decision-making</span>
                              </li>
                          </ul>

                    </div>
                  </div> */}
                    {/* //to do: use ExpandableVerticalSections */}
                    <ExpandableVerticalSections />
                  </div>
                </div>
              </div>
            </div>

            <div className="transform_strat_wrapper">
              <div className="transform_strat_block">
                <h1 className="transform_strat_head">
                  Transform Your Strategic Intelligence
                </h1>
                <p className="transform_strat_subhead mb-1">
                  Leading enterprises are moving from periodic research to
                  continuous intelligence.
                </p>
                <p className="transform_strat_subhead mt-0">
                  Join the platform redefining strategic decision-making.
                </p>
              </div>
              <div class="button-container">
                {/* <a href="#login_form_section"> <button className="sign_started btn" >Sign In to Get Started <FeatherIcon.ArrowRight className='comp_icon ml-1' width={"16px"}/></button></a> */}
                <a href="#login_form_section">
                  {" "}
                  <button className="explore_platform btn">
                    Explore Platform{" "}
                    <FeatherIcon.ArrowRight
                      className="comp_icon ml-1"
                      width={"16px"}
                    />
                  </button>
                </a>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <LoginFooter />
      </div>

      {/* New Login Page Date */}
    </div>
  );
};

export default Login;

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
